// extracted by mini-css-extract-plugin
module.exports = {"iphone5":"screen and (max-width: 320px)","wrapper":"wrapper-1_eje","button":"button-3cGq4","button_back":"button_back-16ZMk","button_continue":"button_continue-2iim2"};